import { useSubscription } from "@apollo/client";
import { getCurrentUserToken } from "config/auth";
import { CompanyUser } from "generated/graphql";
import { useCurrentUser } from "hooks";
import moment from "moment";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CurrentUserSubscription } from "./useCurrentUser";

export interface RequestMetadata {
  loading: boolean;
  error: any;
}
export const LOG_OUT_CODE = [401, 403, 422];
export const useAuthState = (): [boolean, CompanyUser, RequestMetadata] => {
  const navigate = useNavigate();
  const location = useLocation();
  const { code, user, loading, error } = useCurrentUser();

  useSubscription(CurrentUserSubscription, {
    variables: { clientId: user?.company_user_clientId },
    onSubscriptionData(options) {
      if (options.subscriptionData.data.clientDeactivation === user?.company_user_clientId) {
        navigate("/logout");
      }
    },
  });

  useEffect(() => {
    const { tokenExpDate } = getCurrentUserToken();
    if (error && code === 422) {
      navigate("/logout");
    } else if (tokenExpDate) {
      if (moment(new Date(Number(tokenExpDate))).isBefore(new Date())) {
        navigate("/logout");
      }
    }
  }, [navigate, error, code, location.pathname]);

  return [Boolean(user), user, { loading, error }];
};
